/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiInvoice, InvoiceCancellationOptions, LockElement, LockedContextDto, MarkAsAdmonishedOptions, MarkAsPaidOptions } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of InvoicesController.
 */
export class InvoicesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /invoices:payment
     */
    public startOrderCashPayment(orderId: string): Promise<Result<ApiInvoice[]>> {
        const query = new URLSearchParams();
        query.set('orderId', `${orderId}`);

        return this.http.post<Result<ApiInvoice[]>, undefined>('/invoices:payment', undefined, query);
    }

    /**
     * Calls POST /invoices/{invoiceId}:payment
     */
    public startInvoiceCashPayment(invoiceId: string): Promise<Result<ApiInvoice[]>> {
        return this.http.post<Result<ApiInvoice[]>, undefined>(`/invoices/${invoiceId}:payment`, undefined);
    }

    /**
     * Calls PATCH /invoices/payment_completed_at
     */
    public markAsPaid(options: MarkAsPaidOptions): Promise<Result<number>> {
        return this.http.patch<Result<number>, MarkAsPaidOptions>('/invoices/payment_completed_at', options);
    }

    /**
     * Calls PATCH /invoices/admonished_at
     */
    public markAsAdmonished(options: MarkAsAdmonishedOptions): Promise<Result<number>> {
        return this.http.patch<Result<number>, MarkAsAdmonishedOptions>('/invoices/admonished_at', options);
    }

    /**
     * Calls POST /invoices:cancel
     */
    public cancelInvoice(invoiceCancellationOptions: InvoiceCancellationOptions): Promise<Result<ApiInvoice>> {
        return this.http.post<Result<ApiInvoice>, InvoiceCancellationOptions>('/invoices:cancel', invoiceCancellationOptions);
    }

    /**
     * Calls POST /invoices:prefill
     */
    public createPrefilled(): Promise<Result<ApiInvoice>> {
        return this.http.post<Result<ApiInvoice>, undefined>('/invoices:prefill', undefined);
    }

    /**
     * Calls POST /invoices/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiInvoice>>> {
        return this.http.post<Result<LockedContextDto<ApiInvoice>>, undefined>(`/invoices/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /invoices/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiInvoice>> {
        return this.http.post<Result<ApiInvoice>, undefined>(`/invoices/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /invoices/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiInvoice[]>> {
        return this.http.post<Result<ApiInvoice[]>, string[]>('/invoices/locks', ids);
    }

    /**
     * Calls POST /invoices/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/invoices/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /invoices/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/invoices/${primaryId}/locks`);
    }

    /**
     * Calls GET /invoices/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiInvoice>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiInvoice>>(`/invoices/${primaryId}`, query);
    }

    /**
     * Calls POST /invoices
     */
    public add(dto: ApiInvoice): Promise<Result<ApiInvoice>> {
        return this.http.post<Result<ApiInvoice>, ApiInvoice>('/invoices', dto);
    }

    /**
     * Calls PUT /invoices/{primaryId}
     */
    public update(dto: ApiInvoice, primaryId: string): Promise<Result<ApiInvoice>> {
        return this.http.put<Result<ApiInvoice>, ApiInvoice>(`/invoices/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /invoices
     */
    public putRange(dtos: ApiInvoice[]): Promise<Result<ApiInvoice[]>> {
        return this.http.patch<Result<ApiInvoice[]>, ApiInvoice[]>('/invoices', dtos);
    }

    /**
     * Calls DELETE /invoices/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/invoices/${primaryId}`);
    }

    /**
     * Calls POST /invoices:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiInvoice>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiInvoice>>, ListRequestWithIds>('/invoices:batch', listRequest, query);
    }

    /**
     * Calls POST /invoices:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiInvoice>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiInvoice>>, ListRequest>('/invoices:query', listRequest, query);
    }

    /**
     * Calls GET /invoices:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiInvoice>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiInvoice>>>('/invoices:query', query);
    }
}
